import React from 'react';

interface IconStepSearchProps {
  className?: string;
  size?: number;
}

export const IconStepSearch: React.FC<IconStepSearchProps> = ({ className = '', size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#725CFF"
      />
      <path
        d="M27.5 27.4995L23.8833 23.8828"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 25.8333C22.8486 25.8333 25.8333 22.8486 25.8333 19.1667C25.8333 15.4848 22.8486 12.5 19.1667 12.5C15.4848 12.5 12.5 15.4848 12.5 19.1667C12.5 22.8486 15.4848 25.8333 19.1667 25.8333Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconStepSearch;
